import { ChartService } from "./chart.service";
import { type StablecoinLatestDO } from "../models/pie-chart.models";

export class PieChartService {
  constructor(private chartService:ChartService) { }

  async loadStablecoinsLatest(): Promise<StablecoinLatestDO> {
    return await this.chartService.load(`latest/stablecoins`);
  }

  async load(chartId:string) {
    const data = await this.chartService.load(chartId);
    return data;
  }

  async loadV2(chartId:string) {
    const data = await this.chartService.loadV2(chartId);
    return data;
  }
}